module.exports = __webpack_public_path__ + "img/game_tiyu_quanji.ec444e76.png";